export default "__VITE_ASSET__EPhE5GeQ__"